export default __webpack_public_path__ + "static/sanjayRakesh3-d994ea2ad7efaee6402a5289821b6241.jpg";